wrappedQueryRef